var timerId;

export const debounce = function (func, timeout = 300) {
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};



// WEBPACK FOOTER //
// ./utils/debounce.js